let seo = require('../../../actions/seo');
let utils = require('../../../actions/utils');
let content = require('../../../actions/layout/content');
let layoutGroup = require('../../groups/layout');

module.exports = [
    utils.set('layout', 'empty')
];



// WEBPACK FOOTER //
// ./signals/pages/health/index.js